import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEyeSlash } from "@fortawesome/pro-solid-svg-icons"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { StandardButton } from "../../../../buttons/StandardButton"

const useStyles = makeStyles()((theme) => ({
    wrap: {
        padding: ".5rem 1rem",
        borderBottom: `1px solid ${theme.palette.tailwind.slate[300]}`,
        color: theme.palette.tailwind.slate[600],
    },
    icon: {
        fontSize: ".875rem",
    },
}))

type HiddenResourcesNoticeProps = Readonly<{
    count: number
    onShowAll: () => void
}>

export function HiddenResourcesNotice({ count, onShowAll }: HiddenResourcesNoticeProps) {
    const { classes } = useStyles()

    return (
        <Stack direction="row" gap=".5rem" alignItems="center" className={classes.wrap}>
            <FontAwesomeIcon icon={faEyeSlash} className={classes.icon} />
            <LocalizedStrict id="create-order-timeline-meeting-availability-hidden-count" vars={{ count }}>
                <Typography variant="body2">{count} resources hidden</Typography>
            </LocalizedStrict>
            <LocalizedStrict id="create-order-timeline-meeting-availability-show-all-button">
                <StandardButton color="grey" fullWidth={false} variant="text" size="small" onClick={onShowAll}>
                    Show all
                </StandardButton>
            </LocalizedStrict>
        </Stack>
    )
}
